










































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';

@Component({
    name: 'quarter-summary-card-content',
})
export default class QuarterSummaryCardContent extends Vue {
    @Prop({ required: true })
    quarterHumidityReport!: { id: number; humidity: number }[];

    @Prop({ required: true })
    quarterTemperatureReport!: { id: number; temperature: number }[];

    dataCenterSelected: number = DataCenters.DATA_CENTER_CARACAS.id;
    dataCenterValenciaSelected: boolean = false;
    DATA_CENTER_CCS_ID: number = DataCenters.DATA_CENTER_CARACAS.id;
    DATA_CENTER_CCS_NAME: string = DataCenters.DATA_CENTER_CARACAS.alias;
    DATA_CENTER_VAL_ID: number = DataCenters.DATA_CENTER_VALENCIA.id;
    DATA_CENTER_VAL_NAME: string = DataCenters.DATA_CENTER_VALENCIA.alias;
    temperatureItem: { id: number; temperature: number } | undefined;
    humidityItem: { id: number; humidity: number } | undefined;

    changeDataCenter(dataCenterId: number) {
        this.dataCenterSelected = dataCenterId;
        this.dataCenterValenciaSelected = !this.dataCenterValenciaSelected;
    }

    getCurrentItem() {
        this.temperatureItem = this.quarterTemperatureReport.find(
            element => element.id === this.dataCenterSelected,
        );
        this.humidityItem = this.quarterHumidityReport.find(
            element => element.id === this.dataCenterSelected,
        );
    }

    @Watch('dataCenterValenciaSelected')
    changeValues() {
        this.getCurrentItem();
    }

    created() {
        this.getCurrentItem();
    }
}
